import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {Observable,} from "rxjs";
import {MyTraceyComponentState, MyTraceyTabs} from "@pages";
import {
    MY_TRACEY,
    MY_TRACEY_ENTRY,
    MY_TRACEY_FAVORITES,
    MY_TRACEY_RESULTS,
    MY_TRACEY_UPCOMING
} from "../app-routing.module";
import {map} from "rxjs/operators";
import {MyTraceyDataStore} from "@store";


export const MyTraceyInitResolver: ResolveFn<boolean> =
    (route: ActivatedRouteSnapshot, _: RouterStateSnapshot,
     store: MyTraceyDataStore = inject(MyTraceyDataStore)): Observable<boolean> => {
            const router = inject(Router);
            const childRoute = route.firstChild;

            const hasQueryParams = route.queryParams && Object.keys(route.queryParams).length > 0;
            if (hasQueryParams && childRoute) {
                    const activeTab : MyTraceyTabs = childRoute.data['activeTab'];
                    const activeState: MyTraceyComponentState = childRoute.data['state'];
                    if (activeState === MyTraceyComponentState.TABS) {
                        let url = MY_TRACEY;

                        switch (activeTab) {
                            case MyTraceyTabs.FAVORITES:
                                url = MY_TRACEY_FAVORITES;
                                break;
                            case MyTraceyTabs.UPCOMING:
                                url = MY_TRACEY_UPCOMING;
                                break;
                            case MyTraceyTabs.RESULTS:
                                url = MY_TRACEY_RESULTS;
                                break;
                        }
                        router.navigate([url]);
                    }
            }

        return store.preloadAll().pipe(
            map(() => true)
        );
};